import {BaseSyntheticEvent, useRef} from "react";
import {flushSync} from "react-dom";
import {FieldValues, UseFormReturn} from "react-hook-form";

interface useSubmitWrapperOptions<TFieldValues extends FieldValues, TResponse> {
  methods: UseFormReturn<TFieldValues>;
  handleSubmit: (onSubmit: (data: TFieldValues) => Promise<TResponse>) => (e?: BaseSyntheticEvent) => Promise<void>;
  onSubmit: (data: TFieldValues) => Promise<TResponse>;
  isSuccess: (response: TResponse | null) => boolean;
  onSuccess: (response: TResponse) => void;
}

//This is a giant hack to get around the issue with the blocker. UseBlocker has a race condition with React Hook Form formState.
// If we don't await and flush the reset of the form, the blocker may not be in the correct state when we try to navigate
// throwing an that we were unblocked and still trying to proceed.
//https://github.com/remix-run/react-router/discussions/11599
export function useSubmitWrapper<TFieldValues extends FieldValues, TResponse>({
  methods,
  handleSubmit,
  onSubmit,
  isSuccess,
  onSuccess,
}: useSubmitWrapperOptions<TFieldValues, TResponse>) {
  const responseRef = useRef<TResponse | null>(null);

  return async (e?: BaseSyntheticEvent): Promise<void> => {
    e?.preventDefault();
    responseRef.current = null;

    const wrappedSubmit = async (data: TFieldValues): Promise<TResponse> => {
      const result = await onSubmit(data);
      responseRef.current = result;
      return result;
    };

    await handleSubmit(wrappedSubmit)(e);

    if (isSuccess(responseRef.current)) {
      flushSync(() => {
        methods.reset(undefined, {
          keepDirty: false,
          keepValues: true,
        });
      });
      onSuccess(responseRef.current as TResponse);
    }
  };
}
